import { createAction, props } from '@ngrx/store';

import { FeatureFlagToggleList } from '../../interface/feature-flags.interfaces';

export const updated = createAction('[Feature Flags - Toggles] Updated', props<FeatureFlagToggleList>());
